<section class="monitored-area-container">
  <div class="header-actions">
    <button mat-button class="back-button" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Voltar
    </button>
  </div>

  @if (indicators()) {
    <div class="mapa-totalizadores">
      <app-plots-map
        class="map-monitored-area"
        [monitAreaIds]="monitoringAreaIds"
        [cultureName]="areaInfo()?.cultureName ?? undefined"
        [selectedPlotId]="selectedPlot()?.plotId ?? null"
        (plotClick)="onPlotClicked($event)"
      ></app-plots-map>
      <div class="totalizadores-legenda">
        <div class="totalizadores">
          <div id="monitored-area-totalizer">
            <span>Área Monitorada (ha)</span>
            <p>{{ indicators()!.monitoredAreaHa | number: "1.2-2" }}</p>
          </div>

          <div id="area-agricola-totalizador">
            <span>Área agricola (ha)</span>
            <p>{{ indicators()!.agriculturalAreaHa | number: "1.2-2" }}</p>
          </div>
        </div>

        <div class="legenda">
          @for (legend of legends(); track legend.indicatorKey) {
            <div class="texto">
              <div class="info">
                <div
                  class="color"
                  [style.background-color]="getLegendCssColor(legend.status)"
                ></div>

                <p class="title">{{ getPlotStatus(legend.status) }}</p>
              </div>
              <p class="valor">
                {{ indicators()![legend.indicatorKey] | number: "1.2-2" }} ha
              </p>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Legenda ZARC -->
    <div class="zarc-legend">
      <span class="zarc-legend__label">Legenda ZARC:</span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--20">20%</span>
        Menor Risco (20%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--30">30%</span>
        Risco Médio (30%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--40">40%</span>
        Maior Risco (40%)
      </span>
      <span class="zarc-legend__item">
        <span class="zarc-badge zarc-badge--no-zoning">Fora do Zoneamento</span>
      </span>
    </div>

    <div class="table-monitored-area">
      @if (isLoading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      } @else {
        <div style="padding-top: 4px"></div>
      }

      <!-- Label com data do último processamento -->
      @if (indicators()?.metricsProcessingDate) {
        <div class="metrics-processing-date">
          <span
            >Data do último processamento:
            {{
              indicators()!.metricsProcessingDate | date: "dd/MM/yyyy" : "UTC"
            }}</span
          >
        </div>
      }

      <mat-card appearance="outlined">
        <div class="table-container" #tableContainer>
          <mat-table
            #table
            [dataSource]="dataSource()"
            matSort
            matSortStart="asc"
            (matSortChange)="onSortChange($event)"
            class="table mat-elevation-z8"
          >
            <!-- Plot ID -->
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td
                mat-cell
                *matCellDef="let element; let i = index; table: table"
              >
                {{ getRowNumber(i) }}
              </td>
            </ng-container>
            <!-- Aviso Column -->
            <ng-container matColumnDef="warningAlert">
              <th mat-header-cell *matHeaderCellDef>Aviso/Alerta</th>
              <td mat-cell *matCellDef="let element; table: table">
                @if (element.warning) {
                  <mat-icon
                    [class.has-value]="element.warning"
                    [style.color]="element.warning ? '#4caf50' : 'inherit'"
                    >{{ element.warning ? "circle" : "remove" }}</mat-icon
                  >
                } @else if (element.alert) {
                  <mat-icon
                    [class.has-value]="element.alert"
                    [style.color]="element.alert ? '#f44336' : 'inherit'"
                    >{{ element.alert ? "warning" : "remove" }}</mat-icon
                  >
                } @else {
                  <mat-icon>{{ "remove" }}</mat-icon>
                }
              </td>
            </ng-container>

            <!-- Plot ID -->
            <ng-container matColumnDef="plotId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                ID TALHÃO
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{ element.plotId }}
              </td>
            </ng-container>

            <!-- Plot Status (renomeado para Status do Talhão) -->
            <ng-container matColumnDef="plotStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Status do Talhão
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{ element.plotStatus }}
              </td>
            </ng-container>

            <!-- Plot Area -->
            <ng-container matColumnDef="plotArea">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Área (ha)
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{
                  element.plotArea !== null
                    ? (element.plotArea | number: "1.2-2")
                    : "-"
                }}
              </td>
            </ng-container>

            <!-- Emergency Date -->
            <ng-container matColumnDef="emergencyDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Data de Emergência
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{
                  element.emergencyDate
                    ? (element.emergencyDate | date: "dd/MM/yyyy" : "UTC")
                    : "-"
                }}
              </td>
            </ng-container>

            <!-- Senescence Date -->
            <ng-container matColumnDef="senescenceDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Data de Senescência
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{
                  element.senescenceDate
                    ? (element.senescenceDate | date: "dd/MM/yyyy" : "UTC")
                    : "-"
                }}
              </td>
            </ng-container>

            <!-- Harvest Date -->
            <ng-container matColumnDef="harvestDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Apto Colheita
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{
                  element.harvestDate
                    ? (element.harvestDate | date: "dd/MM/yyyy" : "UTC")
                    : "-"
                }}
              </td>
            </ng-container>

            <!-- Final Harvest Date -->
            <ng-container matColumnDef="finalHarvestDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Colheita
              </th>
              <td mat-cell *matCellDef="let element; table: table">
                {{
                  element.finalHarvestDate
                    ? (element.finalHarvestDate | date: "dd/MM/yyyy" : "UTC")
                    : "-"
                }}
              </td>
            </ng-container>

            <!-- ZARC -->
            <ng-container matColumnDef="zarc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ZARC</th>
              <td mat-cell *matCellDef="let element; table: table">
                @if (element.zarcRisk !== null) {
                  <!-- Risco encontrado: 20 | 30 | 40 -->
                  <span class="zarc-badge zarc-badge--{{ element.zarcRisk }}">
                    {{ element.zarcRisk }}%
                  </span>
                } @else if (element.zarcCalculatedAt !== null) {
                  <!-- Cálculo executado mas sem correspondência no ZARC -->
                  <span
                    class="zarc-badge zarc-badge--no-zoning"
                    matTooltip="Cultura válida, mas não há zoneamento ZARC disponível para este município/ciclo/solo"
                  >
                    Fora do Zoneamento
                  </span>
                } @else {
                  <!-- Ainda não processado ou sem dados suficientes -->
                  <span>-</span>
                }
              </td>
            </ng-container>

            <!-- Time Series -->
            <ng-container matColumnDef="timeSeries">
              <th mat-header-cell *matHeaderCellDef>Série Temporal</th>
              <td mat-cell *matCellDef="let element" class="icon-cell">
                <button
                  mat-icon-button
                  (click)="openNDVIChart(element)"
                  aria-label="Ver série temporal NDVI"
                >
                  <mat-icon
                    aria-hidden="false"
                    aria-label="timeline icon"
                    fontIcon="timeline"
                  ></mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Header e Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              [class.selected-row]="row.plotId === selectedPlot()?.plotId"
              *matRowDef="let row; columns: displayedColumns"
              (click)="handleTableRowClick(row)"
            ></tr>
          </mat-table>
          @if (!isLoading() && dataSource().data.length === 0) {
            <div
              class="no-data-message"
              style="text-align: center; padding: 24px"
            >
              Nenhum dado disponível. Área monitorada aguardando talhonamento
            </div>
          }
        </div>
      </mat-card>
      <mat-paginator
        [length]="totalPlots()"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (page)="onPageChange($event)"
        aria-label="Selecionar página"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  }
</section>
